export default (axios, checkHeaders) => ({
  getList (data = {}) {
    return axios.get('/purchase-expense-counts', { params: data.filters || {} })
  },
  postOne (data = {}) {
    return axios.post('/purchase-expense-count', data.body, { params: data.filters || {} })
  },
  getOne (data = {}) {
    return axios.get('/purchase-expense-count/' + data.id, { params: data.filters || {} })
  },
  patchOne (data = {}) {
    return axios.patch('/purchase-expense-count/' + data.id, data.body, { params: data.filters || {} })
  },
  deleteOne (data = {}) {
    return axios.delete('/purchase-expense-count/' + data.id, { params: data.filters || {} })
  }
})
